import { TargetGroupWithTargets } from "components/product-collection/footer/types";
import { TargetRowDataCache } from "../../../context/target-wizard-context";
import { DimensionValue } from "reducers/dimensions-panel/dimensions-panel";

/**
 * Convert targets data for a target group that can be used by the xlsx library to generate an excel file.
 * @param targetGroupWithTargets
 * @param targetsCache
 * @param deliveryValues
 */
export const convertTargetsDataToExcel = (
    targetGroupWithTargets: TargetGroupWithTargets,
    targetsCache: TargetRowDataCache,
    deliveryValues: DimensionValue[]
): any[] => {
    const uniqueFieldNames = new Set<string>();
    const targetGroupTargetIds = new Set<string>();
    targetGroupWithTargets.targets.forEach((target) => {
        targetGroupTargetIds.add(target.id);
        target.filters.forEach((filter) => {
            uniqueFieldNames.add(filter.field_name);
        });
    });

    const fieldNames = Array.from(uniqueFieldNames);
    const deliveryNameColumns = deliveryValues.map((deliveryValue) => deliveryValue.label);
    const deliveryIds = deliveryValues.map((deliveryValue) => deliveryValue.id);
    const headers = [...fieldNames, "door", ...deliveryNameColumns];
    const data = [];
    data.push(headers);

    const targetIds = Object.keys(targetsCache);
    targetIds.forEach((targetId) => {
        if (!targetGroupTargetIds.has(targetId)) {
            return;
        }

        const targetRowData = targetsCache[targetId];
        const filterData = [];
        targetGroupWithTargets.targets.forEach((target) => {
            if (target.id === targetId) {
                target.filters.forEach((filter) => {
                    fieldNames.forEach((fieldName) => {
                        if (filter.field_name === fieldName) {
                            filterData.push(filter.value);
                        }
                    });
                });
            }
        });

        targetRowData.forEach((targetRow) => {
            if (targetRow.doorId && targetRow.deliveryIdMap) {
                const doorValue = targetRow.externalDoorId;
                const deliveryValues = [];
                deliveryIds.forEach((deliveryId) => {
                    const value = targetRow.deliveryIdMap[deliveryId];
                    if (value) {
                        deliveryValues.push(`${value}`);
                    }
                });

                data.push([...filterData, doorValue, ...deliveryValues]);
            }
        });
    });

    return data;
};
